import { useMemo, useState, useEffect } from "react";
import style from '../../componentes/Mapa/Mapa.module.css'
import '../../componentes/Mapa/Mapa.css'
import "./help.css";
import { TextoFormatado } from "../../service/TextService";
import { useTranslation } from 'react-i18next';

const HelpPage = () => {

    const { t, i18n } = useTranslation();
    const [list, setList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [filteredList, setFilteredList] = useState([]);
    const [selectedTopicId, setSelectedTopicId] = useState(null);

    const getHashId = () => {
        return window.location.hash.replace("#", "").trim();
    };

    useEffect(() => {
        const onHashChange = () => {
            const hashId = getHashId();
            setSelectedTopicId(hashId || null);
            setSearchTerm("");
        };

        // lê o hash já na carga inicial (corrige o caso de acessar a URL direto com #19)
        onHashChange();

        window.addEventListener("hashchange", onHashChange);

        return () => window.removeEventListener("hashchange", onHashChange);
    }, []);

    /*const fetchQuestions = async () => {
        const lang = i18n.language.startsWith("pt") ? "ptbr" : "en";
        const res = await fetch(`/flu/Dados/questions/questions_${lang}.json`);
        const data = await res.json();
            
        const parsedList = Object.entries(data.topics).map(([id, item]) => ({
            id,
            ...item
        }));

        setList(parsedList);
        //setFilteredList(parsedList);
        applyHashFilter(parsedList); 
    };*/

    const fetchQuestions = async () => {
        const lang = i18n.language.startsWith("pt") ? "ptbr" : "en";
        const res = await fetch(`/flu/Dados/questions/questions_${lang}.json`);
        const data = await res.json();

        const parsedList = Object.entries(data.topics).map(([id, item]) => ({
            id,
            ...item
        }));

        setList(parsedList);
    };

    /*useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredList(list);
            setLoading(false);
            return;
        }

        setLoading(true);

        const timeout = setTimeout(() => {
            const lowerTerm = searchTerm.toLowerCase();
            const filtered = list.filter(item =>
                item.title.toLowerCase().includes(lowerTerm) ||
                item.content.toLowerCase().includes(lowerTerm)
            );
            setFilteredList(filtered);
            setLoading(false);
        }, 1000); 

        return () => clearTimeout(timeout);
    }, [searchTerm, list]);*/

    useEffect(() => {
        setLoading(true);

        const timeout = setTimeout(() => {
            let result = list;

            if (selectedTopicId) {
                result = result.filter(item => String(item.id) === String(selectedTopicId));
            }

            if (searchTerm.trim()) {
                const lowerTerm = searchTerm.toLowerCase();

                result = result.filter(item =>
                    item.title.toLowerCase().includes(lowerTerm) ||
                    item.content.toLowerCase().includes(lowerTerm)
                );
            }

            setFilteredList(result);
            setLoading(false);
        }, searchTerm.trim() ? 1000 : 0);

        return () => clearTimeout(timeout);
    }, [searchTerm, list]);

    useEffect(() => {
        fetchQuestions();
    }, [i18n.language]);

 

    return (
        <section className="help-section">
            <button
                className="hamburger-button"
                onClick={() => setMenuOpen(!menuOpen)}
            >
                ☰ {t("help.topics")}
            </button>
            <div className="help-content">
                <div className={`menu-help ${menuOpen ? 'open' : ''}`}>
                    <ul className="menu-list">
                        {list.map((item) => (
                            <li className="title-topic-menu" key={item.id}>
                                <a
                                    className="title-topic-menu-link"
                                    href={`#${item.id}`}
                                    onClick={() => {
                                        setSearchTerm("");
                                        setSelectedTopicId(String(item.id));
                                        setMenuOpen(false);
                                    }}
                                >
                                    <TextoFormatado itemContent={item.title} format={false} />
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="content-topic">
                    <h1 className="title-help-page">{t("help.title")}</h1>
                    <input
                        type="text"
                        className="input-help"
                        placeholder={t("help.search")}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "12px",
                            marginBottom: "24px",
                            borderRadius: "8px",
                        }}
                    />
                    <div className="questions-list">
                        {loading ? (
                            <div className={style.loading}>
                            <div className={style.lds_ring}>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            </div>
                        ) : (
                            filteredList.map((itemContent) => (
                            <div         className={`topic-block ${String(itemContent.id) === String(selectedTopicId) ? 'topic-highlight' : ''}`}
                                key={itemContent.id}
                                id={itemContent.id}
                            >
                                <h3 className="topic-title">
                                <strong>
                                    <TextoFormatado itemContent={itemContent.title} format={true} />
                                </strong>
                                </h3>
                                <TextoFormatado itemContent={itemContent.content} format={true} />
                            </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HelpPage;
